package uz.ferro.erp.feature.order.ui

import HeaderTitleView
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.material.Box
import mui.system.sx
import react.FC
import react.create
import react.router.dom.useSearchParams
import react.useContext
import react.useEffectOnce
import react.useState
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.order.data.OrderRepository
import uz.ferro.erp.feature.order.model.Order
import uz.ferro.erp.navigator.NavigationPage
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.AppText
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.GenericPage
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.util.styleInMobile
import web.cssom.Auto
import web.cssom.px

val OrderListPage = FC {
    val navigator = useContext(NavigationContext)
    val queryParams = useSearchParams()
    var orders by useState(listOf<Order>())

    suspend fun loadData() {
        orders = OrderRepository.getOrders()
    }

    useEffectOnce {
        MainScope().launch {
            loadData()
        }
    }

    GenericPage {
        topFullWidthChildren = HeaderTitleView.create {
            this.title = "Mening buyurtmalarim"
        }

        Box {
            sx {
                height = 4.px
            }
        }

        VerticalLayout {
            space = 12.px
            orders.forEach {
                OrderListItemView {
                    order = it
                    onItemClick = { item ->
                        navigator.openPage(NavigationPage.ORDER_DETAILS, item.id!!)
                    }
                }
            }
        }
    }

}